// extracted by mini-css-extract-plugin
export default {"ScreenXSMax":"(max-width: 767px)","arrow":"G5c7db4","arrowDown":"G382de6 G5c7db4 G5e65f6 G62e401 Gc741bf","arrowUp":"G967018 G5c7db4 G5e65f6 G62e401 Ga6e576","arrowBox":"Ge46c16"};